// NOTE: 현재 실패한 요청에도 http code를 200으로 받고 있기 때문에 아래와 같이 custom error를 만들어서 처리합니다
export class ApiError extends Error {
  code: number;
  isSuccess: boolean;
  constructor({ code, message, isSuccess }: { code: number; message: string; isSuccess: boolean }) {
    super(message);
    this.code = code;
    this.isSuccess = isSuccess;
  }
}
